module.exports = __webpack_public_path__ + "static/record-texture-628c8cb7190564ce23788d23673f73f6.png";